
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.602","height":"21.199"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 6221","d":"M10.188 1.412l-9.187 9.186 9.188 9.186","fill":"none","stroke":"#28345c","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    